import React, { FunctionComponent, PropsWithChildren, useCallback } from 'react';
import { FormContext } from '../../Form/Context';
import {
    SubFormFieldMapper,
    SubFormFieldParser,
    useSubFormField,
} from '../../Field/useSubFormField';

export type FieldsetProps = PropsWithChildren<{
    name: string;
}>;

export const Fieldset: FunctionComponent<FieldsetProps> = ({ name, children }) => {
    const fieldValueFromFormValues: SubFormFieldMapper = useCallback((subFormValues) => {
        return subFormValues;
    }, []);

    const formValuesToFieldValue: SubFormFieldParser = useCallback((fieldValue) => {
        return fieldValue;
    }, []);

    const { formContext } = useSubFormField({
        name,
        fieldValueFromFormValues,
        formValuesToFieldValue,
    });

    return <FormContext.Provider value={formContext}>{children}</FormContext.Provider>;
};
